const enum APP_URLs {
    MAIN = '/',
    SIGN_IN = '/sign-in',
    SIGN_IN_ALEXANDR_EREVAN = '/thealexanderyerevan/sign-in',
    SIGN_UP = '/sign-up',
    COURSE = '/course',
    LESSON = '/lesson',
    LOGOUT = '/logout',
    STUDENT_PAGE = '/student',
    EDIT_GROUP = '/editGroup',
    GROUPS = '/groups',
    ORGANISATION_SETTINGS = '/organisationSettings',
    SUPPORT = '/support',
    ATTESTAITON = '/attestation',
    ATTESTATION_STATISTIC = '/attestationStatistic',
    ORGANISATION_PROFILES = '/organisationProfiles',
};

export default APP_URLs;